<template>
  <div class="customer-select-wrapper">
    <select-container
      :title="selectedProvider ? selectedProvider.fullName : 'בחירת עובד'"
      :subtitle="selectedProvider ? getTodayAvailability(selectedProvider.userId) : 'בחירת עובד לתור'"
      icon="pi-user"
      :img="selectedProvider ? selectedProvider.profileImage : undefined"
      :fullName="selectedProvider ? selectedProvider.fullName : undefined"
      @click="containerClick" />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
import { getStringHour } from '@torim-app/utils';
import { useAdminAvailabilityStore } from '@app/stores';
import { useBookableProviders } from '@app/composables/bookable-providers';
import { SelectContainer, useDrawer } from '@torim-app/shared-components';
import SelectProviderDrawerContent from './SelectProviderDrawerContent.vue';

const props = defineProps({
  modelValue: {
    type: String,
    required: false
  }
});

const emit = defineEmits(['providerSelected']);
const { openDrawer, closeDrawer } = useDrawer();
const availabilityStore = useAdminAvailabilityStore();
const { bookableProviders } = useBookableProviders();

const selectedProviderId = ref<string | undefined>(props.modelValue);

const selectedProvider = computed(() => bookableProviders.value.find(p => p.userId === selectedProviderId.value));

const getTodayAvailability = (providerUserId: string) => {
  if (!providerUserId) return '';

  const { end, start } = availabilityStore.getWorkingHoursRange(providerUserId, new Date());
  return start && end ? `יש זמינות היום בין ${getStringHour(end)} - ${getStringHour(start)}` : 'אין זמינות היום';
};

const onProviderSelected = (providerId: string) => {
  selectedProviderId.value = providerId;
  emit('providerSelected', providerId);
};

const containerClick = () => {
  setTimeout(() => {
    openDrawer(SelectProviderDrawerContent, {
      initialProviderId: selectedProviderId.value,
      onProviderSelected: onProviderSelected,
      onCancel: () => {
        closeDrawer();
      }
    }, {
      title: 'בחירת עובד',
      noPadding: true
    });
  }, 300);
};
</script>

<style scoped>
.customer-select-wrapper {
  width: 100%;
}
</style>
